module.exports = __webpack_public_path__ + "0d5cad003eee25906b3eb79fb57d01fa.png";